/**
 * Use for assets in public/ so they work locally and on Vercel.
 * - PUBLIC_URL is set at build time (e.g. "" or homepage from package.json).
 * - encodeURI fixes logo filename with [1] which can 404 on some hosts.
 */
const base = process.env.PUBLIC_URL || '';

export const logoWhiteUrl = base + encodeURI('/logo/logo___White[1].png');

/** Use for any public path (e.g. /image-fix/..., /Image Assets/...) */
export function publicAsset(path) {
  if (!path || typeof path !== 'string') return path;
  const p = path.startsWith('/') ? path : `/${path}`;
  return base + p;
}
